// Daily points: the daily leaderboard. Simple enough to explain in a reel.

export const POINTS = {
  win: 10,
  draw: 5,
  loss: 2,
  /** A loss only scores if the game lasted this many plies (10 moves each). */
  lossMinPlies: 20,
  /** A win by resignation, abandonment or timeout only scores after this many plies (5 moves each). */
  forfeitWinMinPlies: 10,
  /** +1 per this many rating points the opponent had on you, for a win… */
  upsetStep: 50,
  /** …up to this bonus. */
  upsetMax: 10,
  /** Everything on today's variant counts double. */
  featuredMultiplier: 2,
  /** Only the first N games against the same opponent each day score. */
  sameOpponentCap: 3,
  challenge: { win: 20, draw: 8, loss: 3 },
} as const;

export type Outcome = 'win' | 'draw' | 'loss';

const FORFEITS = new Set(['resign', 'abandon', 'timeout']);

export function gamePoints(opts: {
  outcome: Outcome;
  myRating: number;
  oppRating: number;
  plies: number;
  featured: boolean;
  /** End reason; quick forfeits don't score (stops win-trading between accounts). */
  reason?: string;
}): number {
  let pts = 0;
  if (opts.outcome === 'win' && opts.reason && FORFEITS.has(opts.reason) && opts.plies < POINTS.forfeitWinMinPlies) pts = 0;
  else if (opts.outcome === 'win') {
    pts = POINTS.win;
    const gap = opts.oppRating - opts.myRating;
    if (gap > 0) pts += Math.min(POINTS.upsetMax, Math.floor(gap / POINTS.upsetStep));
  } else if (opts.outcome === 'draw') pts = POINTS.draw;
  else if (opts.plies >= POINTS.lossMinPlies) pts = POINTS.loss;
  return opts.featured ? pts * POINTS.featuredMultiplier : pts;
}

export function challengePoints(outcome: Outcome): number {
  return POINTS.challenge[outcome];
}
